import request from '@/utils/request'

export function GetContentDetailApi(data = {}) {
    return request.post(
        process.env.VUE_APP_API_HOST + '/content/detail',
        data,
        {}
    )
}
